const ethereumAddressRegex = /\b0x[a-fA-F0-9]{40}\b/g;
const solanaAddressRegex = /\b[1-9A-HJ-NP-Za-km-z]{32,44}\b/g;
const domainRegex = /\bhttps?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?\b/g;
const doesIncludeLoginMessage = (message) => {
    return ['sign in', 'sign-in', 'login', 'authenticate'].some((loginMessage) => message.toLowerCase().includes(loginMessage));
};
export const findAddresses = (message) => {
    return [
        message.match(solanaAddressRegex) ?? [],
        message.match(ethereumAddressRegex) ?? [],
    ].flat();
};
// "sumdomain.example.com" -> "example.com".
function getRootDomain(url) {
    const hostnameParts = url.hostname.split('.');
    // If the hostname has more than two parts, return the last two parts.
    if (hostnameParts.length > 2) {
        try {
            return new URL(hostnameParts.slice(-2).join('.'));
        }
        catch (err) {
            return new URL(`https://${hostnameParts.slice(-2).join('.')}`);
        }
    }
    return url;
}
// Returns a list of unique domains in the message.
// We only focus on root domains since, for example, a TOS agreement might be hosted on a subdomain.
export const findDomains = (message) => {
    const domainStrings = message.match(domainRegex) ?? [];
    const uniqueRootDomains = new Set();
    const uniqueURLs = new Array();
    domainStrings.forEach((domainString) => {
        let url;
        try {
            url = getRootDomain(new URL(domainString));
        }
        catch (err) {
            try {
                if (domainString.startsWith('www.')) {
                    // www.test.com -> https://test.com.
                    domainString = `https://${domainString.split('www.')[1]}`;
                    url = getRootDomain(new URL(domainString));
                }
                if (!domainString.startsWith('http')) {
                    domainString = `https://${domainString}`;
                    url = getRootDomain(new URL(domainString));
                }
            }
            catch (err) {
                return null;
            }
        }
        finally {
            if (url?.hostname && !uniqueRootDomains.has(url.hostname)) {
                uniqueURLs.push(url);
                uniqueRootDomains.add(url.hostname);
            }
        }
    });
    return uniqueURLs;
};
export const tryParsingSIWE = ({ address, message, url, simulationResult, }) => {
    const includesLoginMessage = doesIncludeLoginMessage(message);
    if (!includesLoginMessage) {
        return;
    }
    // If the message contains addresses, ensure
    // 1. it includes just one unique address;
    // 2. the unique address matches the user's address.
    const foundAddresses = Array.from(new Set(findAddresses(message)));
    if (foundAddresses.length > 1) {
        return;
    }
    if (foundAddresses.some((addressInMessage) => addressInMessage.toLowerCase() !== address.toLowerCase())) {
        return;
    }
    // If the message contains domains, ensure
    // 1. it includes just one unique root domain;
    // 2. the domain matches the dApp domain (the passed "url" parameter).
    // Note: we only check domains before the "Resources" keyword, see https://eips.ethereum.org/EIPS/eip-4361#message-format.
    const foundDomains = findDomains(message.split('Resources')[0]);
    if (foundDomains.length > 1) {
        return;
    }
    if (foundDomains.some((domainInMessage) => domainInMessage.hostname !== url.hostname)) {
        return;
    }
    simulationResult.kind = {
        kind: 'SIWE',
        info: {
            date: new Date(),
            statement: `Sign in to ${url.hostname}.`,
        },
    };
    return;
};
